// Config web pública do Firebase. Segurança vive no console (Authorized Domains
// + hd=pontotel.com.br no signIn), não no apiKey. Ver ADR 0001.
import { initializeApp, type FirebaseApp } from 'firebase/app';
import { getAuth, type Auth } from 'firebase/auth';

const firebaseConfig = {
  apiKey: 'AIzaSyAhsLoFY_9cM0fSEF7tSSNBEYAWFk-f1CY',
  authDomain: 'pontotel-analisador-afd-aej.firebaseapp.com',
  projectId: 'pontotel-analisador-afd-aej',
  appId: '1:1005878905825:web:5f8c96030cc5d3ccba60a0',
} as const;

let app: FirebaseApp | null = null;
let authInstance: Auth | null = null;

export function getFirebaseApp(): FirebaseApp {
  if (!app) app = initializeApp(firebaseConfig);
  return app;
}

export function getFirebaseAuth(): Auth {
  if (!authInstance) authInstance = getAuth(getFirebaseApp());
  return authInstance;
}
